/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChild} from '@fortawesome/pro-duotone-svg-icons';

const SecurityIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faChild} {...props} />
);

export default SecurityIcon;
